<template>
  <article
    class="c-card-course-player br--medium overflow-hidden d-flex flex-column h-100"
    :class="{'completed' : courseStatus.type === 3}"
    >
    <div class="position-relative">
      <figure class="c-card-course-player__cover d-block">
        <img
          class="w-100 h-100 of--cover"
          :src="body.cover"
          alt="">
      </figure>

      <div class="c-card-course-player__controls position-absolute w-100 h-100 p-3">
        <div class="position-relative h-100">
          <div v-if="!spec" class="c-card-course-player__actions">
            <button v-if="false" class="c-link c-link--white me-2">
              <div class="iconf-star"></div>
            </button>

            <Dropdown v-model="switcher" class="c-more-actions">
              <template v-slot:toggle>
                <button @click="switcher = !switcher" class="c-more-actions__button">
                  <div class="d-flex">
                    <Icon icon="uiw:setting" class="fs-18 me-1" />
                    <Icon icon="ant-design:caret-down-filled" class="fs-18" />
                  </div>
                </button>
              </template>
              <template v-slot:menu>
                <ul>
                  <li>
                    <button
                      @click="hide()"
                      :disabled="isLoading"
                      class="c-more-actions__item d-flex"
                    >
                      <Icon :icon="hideButton.icon" class="fs-18 me-2" />
                      <span class="fs-14 w-sbold">
                        {{ hideButton.label }}
                      </span>
                    </button>
                  </li>
                  <li v-if="!hasFullAccess" color="alert">
                    <button
                      @click="unenroll()"
                      :disabled="isLoading"
                      class="c-more-actions__item d-flex">
                      <Icon icon="ci:trash-full" class="fs-18 me-2" />
                      <span class="fs-14 w-sbold">Eliminar</span>
                    </button>
                  </li>
                </ul>
              </template>
            </Dropdown>
          </div>

          <div class="d-flex justify-content-center align-items-center h-100">
            <a
              v-if="body.access.enable && nextLesson"
              :href="nextLesson"
              class="c-button c-button--primary medium d-flex align-items-center"
            >
              <i class="iconf-play"></i>
              <span class="ms-2">{{ courseStatus.label }}</span>
            </a>
            <button
              v-else
              @click="isVisibleLockMessage = true"
              class="c-button c-button--primary medium d-flex align-items-center"
            >
              <i class="iconf-play"></i>
              <span class="ms-2">{{ courseStatus.label }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="c-card-course-player__body p-3 ps-4 d-flex
      flex-column justify-content-between flex-grow-1">
      <div class="d-flex mb-3 align-items-start">
        <h4 class="c-card-course-player__title fs-18 w-bold mb-3">
          <a :href="body.url">{{body.title}}</a>
        </h4>
        <div v-if="body.certificate && body.certificate.course_certificate" class="ps-3">
          <div class="c-card-course-player__badge rounded
            ax-shadow center d-flex
            justify-content-center align-items-center">
            <i class="iconf-medal fs-21"></i>
          </div>
        </div>
      </div>

      <div>
        <p
          v-if="courseStatus.type === 1 || courseStatus.type === 2"
          class="fs-14 pri-alt w-sbold mb-0"
        >
          {{courseStatus.description}}
        </p>

        <div v-if="courseStatus.type === 3" class="d-flex">
          <div class="c-card-course-player__ok rounded bg-pri-color white d-flex
            justify-content-center align-items-center">
            <i class="iconf-ok d-flex align-items-center"></i>
          </div>
          <span class="ms-2 fs-14 w-medium white">Curso completado</span>
        </div>

        <Progress
          v-if="courseStatus.type === 2 || courseStatus.type === 3"
          class="mt-1"
          :percentage="body.progress.percentage"
          :isSingle="true" />
      </div>
    </div>

    <div
      class="c-card-course-player__locked position-absolute p-3"
      :class="{'visible' : isVisibleLockMessage}"
    >
      <div class="d-flex h-100 flex-column">
        <div class="d-flex justify-content-end w-100">
          <button @click="isVisibleLockMessage = false" class="c-link c-link--gray">
            <Icon icon="ci:close-big" class="mb-3 fs-25 dark-gray" />
          </button>
        </div>
        <div
          class="flex-grow-1 d-flex flex-column
            justify-content-center text-center align-items-center"
        >
          <Icon icon="nimbus:lock" class="mb-3 fs-35 dark-gray" />

          <p class="fs-18 w-bold mb-2 darks">
            {{lockedMessageTitle}}
          </p>

          <p class="fs-14 mb-3 w-medium">
            No lo dejes en espera, a un solo precio disfruta este y
            <span class="third-color w-bold">más de 100 cursos</span>
            que tenemos para tí
          </p>

          <a href="/planes" class="c-button c-button--primary d-inline-block medium mb-1">
            Ver planes
          </a>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { Icon } from '@iconify/vue2';

export default {
  data() {
    return {
      switcher: false,
      isVisibleLockMessage: false,

      isLoading: false,
    };
  },
  props: ['body', 'user', 'list', 'total', 'empty', 'spec'],
  components: {
    Icon,
    Progress: () => import(/* webpackChunkName: "progress-bar" */'../ProgressBar.vue'),
    Dropdown: () => import(/* webpackChunkName: "dropdown" */'../ui/Dropdown.vue'),
  },
  computed: {
    nextLesson() {
      const url = this.body.next_lesson.split('/curso/');

      return (this.spec) ? `${url[0]}/curso/${this.$route.params.speciality_id}/${url[1]}` : this.body.next_lesson;
    },
    courseStatus() {
      let status = { label: '', type: -1 };

      if (this.body.progress) {
        const percentage = Number(this.body.progress.percentage);
        if (percentage === 0) {
          status = {
            label: 'Empezar curso',
            type: 1,
            description: `${this.body.duration} de duración`,
          };
        } else if (percentage >= 100) {
          status = {
            label: 'Ver de nuevo',
            type: 2,
            description: `${this.body.progress.percentage}% de clases vistas`,
          };
        } else {
          status = {
            label: 'Continuar curso',
            type: 2,
            description: `${this.body.progress.percentage}% de clases vistas`,
          };
        }
      } else {
        status = {
          label: 'Empezar curso',
          type: 1,
          description: '',
        };
      }

      if (this.body.certificate && this.body.certificate.user_certificate) {
        status = {
          ...status,
          type: 3,
        };
      }

      return status;
    },

    hideButton() {
      return {
        label: (this.$route.query.type && this.$route.query.type === 'hide') ? 'Mostrar' : 'Ocultar',
        icon: (this.$route.query.type && this.$route.query.type === 'hide') ? 'bi:eye-fill' : 'bi:eye-slash-fill',
      };
    },
    lockedMessageTitle() {
      return (this.body.access.plan === 'free') ? 'Tu acceso gratuito ha terminado' : 'Tu acceso al curso ha terminado';
    },

    hasFullAccess() {
      return this.body.access && this.body.access.plan === 'vitalicio';
    },
  },
  methods: {
    getProductREST(operation) {
      return `${window.arcux.api}/profile/${this.user.id}/products/${this.body.id}/${operation}`;
    },

    hide() {
      const request = this.getProductREST('hide');

      this.isLoading = true;

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.updateData();
          }

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    unenroll() {
      const request = this.getProductREST('remove');

      this.isLoading = true;

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then(() => {
          this.updateData();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    updateData() {
      const newList = this.list.filter((co) => co !== this.body);

      this.switcher = false;

      this.$emit('update:list', newList);
      this.$emit('update:total', this.total - 1);
      this.$emit('update:empty', !newList.length);
    },
  },
};
</script>
